// import $ from 'jquery';
import ScrollMagic from 'scrollmagic';

export default function vehiclePageInit() {
    $(document).ready(function() {
        if ($('.section-product').length > 0) {

            let controller = new ScrollMagic.Controller(),
                sectionProductHeight = $('.section-product__wrap').innerHeight() - 640,
                sectionProductSliderHeight = $('.extra-content--product').innerHeight() - 900;

            $('.slide-image').each(function (index) {
                let $this = $(this);
                $this.addClass('slide-image-' + index);
            });

            $('.slide-image-0').addClass('_active');

            $('.extra-content__content-wrap').each(function (index) {
                let $this = $(this);
                $this.addClass('extra-content__content-wrap--trigger-' + index);

                function addActive() {
                    $('.slide-image-' + index).addClass('_active').siblings().removeClass('_active');
                }
                function removeActive() {
                    $('.slide-image-' + (index -1)).addClass('_active').siblings().removeClass('_active');
                }

                new ScrollMagic.Scene({
                    triggerElement: '.extra-content__content-wrap--trigger-' + index,
                    triggerHook: 0.65,
                })
                    .on('enter', addActive)
                    .addTo(controller);

                new ScrollMagic.Scene({
                    triggerElement: '.extra-content__content-wrap--trigger-' + index,
                    triggerHook: 0.7,
                })
                    .on('leave', removeActive)
                    .addTo(controller);
            });

            if ($('.extra-content--product').innerHeight() > 900) {
                new ScrollMagic.Scene({
                    triggerElement: '.extra-content--product',
                    duration: sectionProductSliderHeight,
                    triggerHook: 0.05,
                })
                    .setPin('.image-wrap')
                    .addTo(controller);
            }

            let fixedProductImage = new ScrollMagic.Scene({
                // triggerElement: '.section-product',
                duration: sectionProductHeight,
                triggerHook: 0.27,
                // reverse: true,
            })
                .setPin('.product-main__image img, .product-main__image .product-main__360-wrap')
                .addTo(controller);

            let fixed360ImageControls = new ScrollMagic.Scene({
                // triggerElement: '.section-product',
                duration: sectionProductHeight,
                triggerHook: 0.27,
            })
                .setPin('.product-main__image .image-360')
                .addTo(controller);

            $(window).on('resize', function () {
                if ($(window).width() < 1024 && $('.scrollmagic-pin-spacer').length > 0) {
                    fixedProductImage.removePin('.product-main__image img, .product-main__image .product-main__360-wrap');
                    fixed360ImageControls.removePin('.product-main__image .image-360');
                } else {
                    fixedProductImage.setPin('.product-main__image img, .product-main__image .product-main__360-wrap');
                    fixed360ImageControls.setPin('.product-main__image .image-360');
                }
            });

            new ScrollMagic.Scene({
                triggerElement: '.product-feature-container',
                triggerHook: 0.6,
            })
                .setClassToggle('.product-feature', '_active')
                .addTo(controller);

            function checkMedia() {
                if ($(window).width() < 1023 && controller.enabled()) {
                    controller.enabled(false);
                } else if (!controller.enabled()) {
                    controller.enabled(true);
                }
                controller.update(true);
            }

            checkMedia();

            $(window).on('resize', function() {
                checkMedia();
            });

        }
    });
}